import handleErrors from '../utils/_handleErrors';

class mFormLoginSidebar extends HTMLDivElement {
    constructor() {
        super();

        this.loginSection = document.getElementById('loginSection');
        this.emailForm = document.getElementById('sidebar-co-guest');
        this.registrationSection = document.getElementById('registrationSection');
        this.registrationInputEmail = document.querySelector('#registrationSection #profile-form-email');
        this.authInputEmail = document.querySelector('#authSection #signin-form-signInLogin');
        this.authSection = document.getElementById('authSection');
        this.authForm = document.querySelector('#authSection #signInForm');
        this.forgotPasswordForm = document.querySelector('#authSection #forgotPasswordForm');
        this.forgotPasswordInput = document.getElementById('fp-form-forgotPasswordEmail');
        this.btnAlreadyAccount = document.getElementById('btn-already-account');
    }

    connectedCallback() {
        this.btnAlreadyAccount.addEventListener('click', () => {
            this.showRegisteredForm();
        });

        this.emailForm.addEventListener('sidebar:emailCheck', () => {
            this.submitEmailForm();
        });
    }

    submitEmailForm() {
        const url = this.emailForm.action;
        fetch(url, {
            method: 'POST',
            body: new FormData(this.emailForm),
        })
        .then(handleErrors)
        .then((response) => response.json())
        .then((response) => {
            if (response.emailCustomer) {
            // set email value on create account form
                this.registrationInputEmail.setAttribute('readonly', 'readonly');
                this.registrationSection.querySelector('.type-email').classList.add('is-active');
                this.registrationSection.querySelector('.type-email .input-wrapper').classList.add('valid');
                this.registrationSection.querySelector('.type-email label').classList.add('valid');
                this.registrationInputEmail.value = response.emailCustomer;
                // set email value on signin form
                this.authInputEmail.value = response.emailCustomer;
                this.authForm.querySelector('.type-email').classList.add('is-active');
                this.authForm.querySelector('.type-email .input-wrapper').classList.add('valid');
                this.authForm.querySelector('.type-email label').classList.add('valid');
                this.forgotPasswordInput.value = this.authInputEmail.value;
                this.forgotPasswordForm.querySelector('.type-textfield').classList.add('is-active');
                this.forgotPasswordForm.querySelector('.type-textfield .input-wrapper').classList.add('valid');
                this.forgotPasswordForm.querySelector('.type-textfield label').classList.add('valid');
            }

            if (response.registered) {
                this.authSection.classList.remove('d-none');
                this.loginSection.classList.add('d-none');
            } else {
                this.registrationSection.classList.remove('d-none');
                this.loginSection.classList.add('d-none');
            }
        });
    }

    showRegisteredForm() {
        this.registrationSection.classList.add('d-none');
        this.loginSection.classList.add('d-none');
        this.authSection.classList.remove('d-none');
    }
}

customElements.define('m-form-login-sidebar', mFormLoginSidebar, {
    extends: 'div',
});
